import React from "react";

const Image = ({ src, srcMobile, alt, style, className, pictureClassName, imageRef }) => {
    return (
        <picture style={{ display: 'block' }} className={pictureClassName}>
            <source srcSet={srcMobile || src} media="(max-width: 1023px)" />
            <img
                src={src}
                alt={alt}
                style={style}
                className={className}
                ref={imageRef}
            />
        </picture>
    );
};

export default Image;